<template>
    <section class="mt-5 mb-5" v-if="brands.length > 0">
        <div class="container">
            <slick ref="slick"
                :options="slickOptions">
                <div class="card-slick" v-for="brand in brands">
                    <div class="card-body">
                        <div class="offer-banner text-center">
                            <a :href="appUrl+'/products/'+brand.id+'/brand'">
                                <img :src="appUrl+'/'+brand.icon" :alt="brand.name" class="img-fluid">
                            </a>
                        </div>
                    </div>
                </div>
            </slick>
        </div>
    </section>
</template>
<script>
    import Slick from 'vue-slick';
    export default {
        components: { Slick },
        computed: {},
        data() {
            return {
                brands: [],
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                slickOptions: {
                    dots: true,
                    infinite: true,
                    speed: 800,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }

                    ]
                },
            };
        },
        mounted() {
            this.getBrands();
        },
        methods: {
            getBrands() {
                var that = this;
                axios.get('api/get-brands')
                .then(function(response) {
                    that.brands = response.data.brands;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            next() {
                this.$refs.slick.next();
            },
            prev() {
                this.$refs.slick.prev();
            },
        }
    };
</script>
